<template>
  <div class="teacher-info">
    <div class="info-box">
      <div class="box-title">个人信息</div>
      <div class='box-bd'>
        <div class="txt">任教科目：英语</div>
        <!-- <div class="txt">手机号码：{{userInfo.mobilePhone}}</div> -->
      </div>
      <div class="box-book" v-if="userInfo.bookInfo">
        <div class='box-bd tc'>
          <img :src="userInfo.bookInfo.coverImgUrl" class="cover">
          <div class="book-name">{{formatName(userInfo.bookInfo.bookName)}}</div>
        </div>
        <a class="change-btn" @click="changeBooks()">更换教材</a>
      </div>
    </div>
    <SelectBookDialog  ref="selectBook" v-on:reloadInfo="reloadInfo"></SelectBookDialog>
  </div>
</template>
<script>
import SelectBookDialog from '../components/SelectBookDialog'
export default {
  name: 'TeacherInfo',
  components: {
    SelectBookDialog
  },
  props: {
    userinfo: Object
  },
  data () {
    return {
      userInfo: this.userinfo
    }
  },
  methods: {
    changeBooks () {
      this.$refs.selectBook.init()
    },
    formatName (name) {
      return name.replace('小学英语', '')
    },
    reloadInfo (data) {
      this.userInfo = data
    },
    resetUserInfo () {
      this.userInfo = JSON.parse(window.sessionStorage.getItem('userInfo'))
      console.log(this.userInfo)
    }
  }
}
</script>
<style scoped>
.teacher-info{
    padding: 50px 0;
}
.info-box{
    width: 100%;
    background: #fff;
    margin-bottom: 20px;
    padding: 20px;
    box-sizing: border-box;
}
.box-title{
    border-left: 3px solid #FE793A;
    padding-left: 8px;
    line-height: 1.2;
    margin: 0
}
.box-bd{
    padding: 20px 0 10px;
    font-size: 15px;
    line-height: 2;
}
.box-bd.tc{
    text-align: center;
}
.box-bd .cover{
    width: 120px;
}
.book-name{
    font-size: 14px;
}
.change-btn{
    display: block;
    text-align: center;
    color: #FE793A;
    font-size: 14px;
    cursor: pointer;
}
</style>
